<template>
    <span>{{ value | localizeTime(format) }}</span>
</template>

<script>
export default {
    props: {
        value: String,
        format: String
    }
}
</script>